import { render } from "./PerkConfigFormField.vue?vue&type=template&id=695bd85c"
import script from "./PerkConfigFormField.vue?vue&type=script&lang=js"
export * from "./PerkConfigFormField.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__